import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';
import { b as bem } from './p-c44c2366.js';
import { d as defineCustomElement$2 } from './p-db87170c.js';
import { t as transformTagName } from './p-c01ca34a.js';

const cosmosOptgroupCss = ".cosmos-optgroup{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:2px;padding-bottom:var(--cosmos-optgroup-padding-bottom, 8px)}.cosmos-optgroup__label{--cosmos-text-color:var(--cosmos-optgroup-color);--cosmos-text-font-family:var(--cosmos-optgroup-font-family);--cosmos-text-font-size:var(--cosmos-optgroup-font-size);--cosmos-text-font-style:var(--cosmos-optgroup-font-style);--cosmos-text-font-weight:var(--cosmos-optgroup-font-weight);--cosmos-text-letter-spacing:var(--cosmos-optgroup-letter-spacing);--cosmos-text-line-height:var(--cosmos-optgroup-line-height);--cosmos-text-text-transform:var(--cosmos-optgroup-text-transform);-ms-flex-align:center;align-items:center;display:var(--cosmos-optgroup-display, flex);height:36px;padding:0 8px 0 8px}.cosmos-optgroup--disabled .cosmos-optgroup__label{--cosmos-text-color:rgba(0, 15, 30, 0.6)}.cosmos-optgroup--disabled.cosmos-optgroup--appearance-light .cosmos-optgroup__label{--cosmos-text-color:rgba(255, 255, 255, 0.6)}";
const CosmosOptgroupStyle0 = cosmosOptgroupCss;

const generateClassNames = bem('cosmos-optgroup');
const CosmosOptgroup$1 = /*@__PURE__*/ proxyCustomElement(class CosmosOptgroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleSlotChange = () => {
            this.initOptions();
        };
        this.appearance = 'dark';
        this.disabled = undefined;
        this.label = undefined;
    }
    initOptions() {
        if (this.disabled) {
            const options = Array.from(this.element.querySelectorAll(transformTagName('cosmos-option')));
            options.forEach((option) => {
                option.disabled = true;
            });
        }
    }
    componentWillLoad() {
        this.initOptions();
    }
    render() {
        return (h(Host, { key: 'efa50750e9b07fd63eb8af676ea8d15f092f17d8', role: "group", "aria-label": this.label }, h("div", { key: '11ba648799d9d918153c7467d2f449cfcf528ed8', class: generateClassNames({ disabled: this.disabled, appearance: this.appearance }), part: "base" }, h("div", { key: 'e8ce201dda755797ef8731938354521c09a64948', class: generateClassNames('label') }, h("cosmos-text", { key: '072843982a5dd2ae824f41bde8ab8817cde33f61', exportparts: "base: label", size: "x-small", weight: "medium", clamp: 1, appearance: this.appearance, kind: "subtle" }, this.label)), h("slot", { key: '7f7c5d7fe058311f15138fb1f32fb693d4c488e3', onSlotchange: this.handleSlotChange }))));
    }
    get element() { return this; }
    static get style() { return CosmosOptgroupStyle0; }
}, [1, "cosmos-optgroup", {
        "appearance": [513],
        "disabled": [516],
        "label": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-optgroup", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-optgroup":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosOptgroup$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosOptgroup = CosmosOptgroup$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosOptgroup, defineCustomElement };
